import React, { useEffect } from 'react';
import { APP_VERSION } from '../../version';

const VersionChecker = () => {
  useEffect(() => {
    // Add version parameter to all script and CSS links to bypass cache
    const updateCacheBuster = () => {
      const links = document.querySelectorAll('link[rel="stylesheet"]');
      const scripts = document.querySelectorAll('script[src]');
      
      const cacheBuster = `?v=${APP_VERSION}`;
      
      links.forEach(link => {
        if (!link.href.includes('v=')) {
          link.href = link.href + cacheBuster;
        }
      });
      
      scripts.forEach(script => {
        if (!script.src.includes('v=')) {
          script.src = script.src + cacheBuster;
        }
      });
    };
    
    // Check for version mismatch (if needed)
    const checkVersion = () => {
      // This could be expanded to check against a server-side version if needed
      console.log(`Current version: ${APP_VERSION}`);
    };
    
    updateCacheBuster();
    checkVersion();
  }, []);

  return null;
};

export default VersionChecker;